import { PlannedDemandPageThemeModeConfig } from './types';

const dark: PlannedDemandPageThemeModeConfig = {
  plannedDemandPage: {
    normalButtonBGColor: '#505251',
    normalButtonBorderColor: '2px solid #267DAC',
  },
};

export default dark;
